import {useState} from '#app';
import type {CertificationRequest} from '~/types/infra/CertificationRequest';

export const useCertificationSectionState = () => useState<CertificationRequest[]>('certification-section-state', () => []);
